<template>
  <div class="page">
<div class="div">
<div class="title_header">
  <div >
    <img class="title_image" src="./image/顶部背景@2x.png" alt="">
  </div>

<div class="swipe">
  <div class="myHeader">
<headerTitle  isChange @change="studentChange"/>
</div>

<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
  <van-swipe-item v-for="(item,i) in swiperList" :key="i" @click="goswiper(item)">
    <a :href="item.skipurl">
       <img :src="item.url" height="100%" width="100%" style="border-radius: 8px;"/>
    </a>
  </van-swipe-item>
</van-swipe>
</div>
</div>



<div class="menu">
<div class="menu_row">
   <div style="width:25%" v-for="value in menuList" :key="value.id" @click="goPage(value)">
      <img :src="value.url" alt=""  height="40vw" style="margin:8px;">
      <div style="text-align:center;"> {{value.name}}</div>
  </div>
</div>




<div class="menu_down">
    <div class="center fitnessBox" @click="onReport()">
        <!-- <div class="center_text" @click="onReport()">体测报告 <van-icon name="arrow" /></div> -->
        <!-- <img height="100%" width="100%" style="border-radius: 8px;object-fit: cover;" :src="require('@/assets/image/体测报告btn.jpg')" alt=""> -->
    </div>
    <div class="center trainingBox"  @click="onbodyReport()">
        <!-- <div  class="center_text" @click="onbodyReport()">锻炼报告 <van-icon name="arrow" /></div> -->
        <!-- <img height="100%" width="100%" style="border-radius: 8px;object-fit: cover;" :src="require('@/assets/image/锻炼报告btn.jpg')" alt=""> -->
    </div>


  <!-- <van-row gutter="10">
  <van-col span="12">
    <div>
      <img src="./image/报销管理@2x.png" alt="" width="100%;" style="height:400rpx"  @click="goPage({name:'报销管理'})">
    </div>
  </van-col>
  <van-col span="12">
    <div>
      <img src="./image/工作协同@2x.png" alt="" width="100%;" style="height:49%;margin-bottom:6%;"   @click="goPage({name:'工作协同'})">
      <div style="width:99%">
   <van-badge :content="countAll" >
      <img src="./image/待办工作@2x.png" alt="" width="100%;" style="height:49%"   @click="goPage({name:'待办工作'})">
    </van-badge>
      </div>
 
    </div>
  </van-col>
</van-row> -->
</div>


</div>


</div>
    <VDialog ref="VDialog" :objData="objData" />
    <!-- 内容区域 -->
    <main class="content-container">
      <router-view />
    </main>
<!-- <van-tabbar v-model="active" fixed>
  <van-tabbar-item icon="home-o">首页</van-tabbar-item>
  <van-tabbar-item icon="search" dot>运动之星</van-tabbar-item>
  <van-tabbar-item icon="friends-o" info="5">积分商城</van-tabbar-item>
  <van-tabbar-item icon="setting-o" info="20">个人中心</van-tabbar-item>
</van-tabbar> -->
  </div>
</template>

<script>
import {insertBaseSystemAccountWx,listRotationChart} from '@/api/common'
import headerTitle from "./module/headerTitle.vue";
import VDialog from "@/components/VDialog";

export default {
  components: {
    headerTitle,
    VDialog
  },
  data() {
    return {
      active:'',
     countAll:undefined,
     objData: {
        checked: false,
        num: 3,
        showDialog: false,
      },
     swiperList: [{
      id: 0,
      type: 'image',
      url: require("./image/zhinan.png"),
      skipurl:'',
    }, 
    // {
    //   id: 2,
    //     type: 'image',
    //   url: require("./image/jiqiao.png"),
    //   skipurl:'https://mp.weixin.qq.com/s/lTKf3CvYa_-ROOVUEU3Cew',
    // }
    ],

 
menuList:[
   {
      id: 1,
      name:'学生绑定',
      url: require("./image/个人中心.png"),
    },
    {
      id: 0,
      name:'测训准考证',
      url: require("./image/制证.png"),
    }, 
    {
      id: 2,
      name:'家庭作业',
      url: require("./image/作业.png"),
    },
  
      {
      id: 4,
      name:'阳光跑',
      url: require("./image/阳光跑.png"),
    }, 
    {
      id: 5,
      name:'健康信息申报',
      url: require("./image/绑定.png"),
    },
    //  {
    //   id: 3,
    //   name:'通讯录',
    //   url: require("./image/通讯录@2x.png"),
    // }, 
     {
       id: 6,
       name:'积分商城',
       url: require("./image/商城.png"),
     }, 
     {
       id: 7,
       name:'运动分析',
       url: require("./image/分析.png"),
     }, 
     {
       id: 8,
       name:'运动之星',
       url: require("./image/记录.png"),
     }
],


    studentTitleInfo:{}
    }
  },
  computed: {

  },
  created() {
  },
  mounted () {
    this.init()
    
  },
  methods: {
    studentChange(val){
    this.studentTitleInfo =val
  },
  onReport(){
      let data = JSON.stringify({...this.studentTitleInfo, })
      this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,})
      this.$router.push({path:'bodyForging',query:{data:data}})
  },
    init(){
       const isChecked = localStorage.getItem("isChecked") || false;
        if (!isChecked) {
          this.objData.showDialog = true;
          this.$refs.VDialog.countdown();
        }
          
    },
      goswiper(val){
    // this.$router.push({path:url})
      },
goPage(val){
let url = ''
if (val.name=='学生绑定') {
 url = '/studentBind'
}
else if (val.name=='测训准考证') {
  url = '/admissionTicket'
 }else if (val.name=='家庭作业') {
  url = '/homework'
 }else if (val.name=='健康信息申报') {
  url = '/surveyMgt'
 }else if (val.name=='阳光跑') {
  url = '/sunrunScore'
 }else if (val.name=='积分商城') {
  url = '/integralShop'
 }else if (val.name=='运动分析') {
  url = '/fitnessReportV2'

   let data = JSON.stringify({...this.studentTitleInfo,})
    this.$router.push({path:'fitnessReportV2',query:{data:data}})
  return
 }

 
 
if (url!=='') {
    this.$router.push({path:url})
}else  {
  this.$toast({ icon: "error", message: "暂未开放，敬请期待！！" });
}
},

  }
};
</script>
<style lang="less" scoped>
@header-footer--line-height: 40px;
.page{
  background: #eeeeee;
  height: 100vh;


}
  // background-image: url('./image/顶部背景@2x.png');
	// background-repeat: no-repeat;
	// background-position: center;
	// background-size: cover;


 .title_header{
  position:relative;
  z-index: 0;

}
.title_image{
  width: 100%;
  height: 400rpx;
  position:fixed;
  z-index: -999;
}
  .fitnessBox{
    background-image: url('../../assets/image/体测报告btn.jpg');
	  background-repeat: no-repeat;
	background-size: cover;
  }
  .trainingBox{
    background-image: url('../../assets/image/锻炼报告btn.jpg');
	  background-repeat: no-repeat;
	background-size: cover;
  }
.menu{
  font-size: 13px;
  margin-top: 8px;
  .menu_down{
    text-align: center;
    margin: 10px;


 .center{
        height: 118px;
        line-height: 118px;
        text-align: center;
        position: relative;
        background-color: #fff;
        border-radius:8px;
        margin-top: 16px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        object-fit: cover;
        .center_text{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: 20px;
            font-weight: 700;
            color: #458ff1b9;
        }
        .center_value{
            color: #bbb;
        }
    }


  }
 .menu_row{
    text-align: center;
   display: flex;
   flex-wrap: wrap;
 } 
}
 ::v-deep .van-grid-item__content{
    padding: 16px 6px!important;
  background: #eeeeee;
  }


.userinfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #aaa;
}
.myHeader{
  margin: auto;
  padding-top: 40px;
  width: 90%;
}
.swipe{

}
.my-swipe{
margin: auto;
// margin-top:15px;
width: 90%;
border-radius: 8px;
}
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    // line-height: 400rpx;
    text-align: center;
    border-radius: 8px;
  }
</style>
